(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/common/analytics.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/common/analytics.js');

'use strict';

const productMapping = svs.numbergames.productMapping;
const trackClickChange = (e, _ref) => {
  let {
    prolongHref,
    productName
  } = _ref;
  e.preventDefault();
  svs.components.analytics.trackEvent({
    category: 'betslip_change',
    action: 'yes',
    opt_label: productMapping.getProductId(productName)
  }, () => {
    svs.utils.url.navigate(prolongHref);
  });
};
const trackClickPay = (isWagerUnchanged, _ref2) => {
  let {
    trackingCategory,
    selectedDays,
    productName,
    drawCount
  } = _ref2;
  svs.components.analytics.trackEvent({
    category: trackingCategory,
    action: "prolong_dialog".concat(isWagerUnchanged ? 'NoChange' : 'Change'),
    opt_label: "".concat(selectedDays.join('-'), "-").concat(productMapping.isKeno(productName) ? drawCount : "".concat(drawCount, "v"))
  });
};
const trackProlongIsDuplicate = (duplicateProlong, _ref3) => {
  let {
    trackingCategory,
    productName
  } = _ref3;
  svs.components.analytics.trackEvent({
    category: trackingCategory,
    action: duplicateProlong ? 'Prolong_duplicateProlong' : 'Prolong_duplicateCancel',
    opt_label: productName
  });
};
const trackCloseProlongDialog = trackingCategory => {
  svs.components.analytics.trackEvent({
    category: trackingCategory,
    action: 'close_dialog',
    opt_label: ''
  });
};
const trackSubscriptionPay = (subscriptionHref, trackingCategory) => {
  svs.components.analytics.trackEvent({
    category: trackingCategory,
    action: 'prolong_dialog',
    opt_label: 'prenumerera'
  }, () => {
    svs.utils.url.navigate(subscriptionHref);
  });
};
setGlobal('svs.numbergames.prolong_game.analytics', {
  trackClickChange,
  trackClickPay,
  trackProlongIsDuplicate,
  trackCloseProlongDialog,
  trackSubscriptionPay
});

 })(window);